/*
セレクタを変更
 */
module.exports = function customSelector(){
    var $wrapper = $('.js-select');
    $wrapper.each(function(){
        var $this = $(this);
        var $view = $this.find('.js-select-view');
        var $body = $this.find('.js-select-body');
        $body.on('change', function(){
            location.href = $body.find('option:selected').val();
        });
    });
};



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/customSelector.js
 **/